var ES6Promise = require('es6-promise');
ES6Promise.polyfill();
import axios from 'axios';
import {
    userExistUrl,
    getPinUrl,
    opplysningenLookupUrl,
    passwordLoginUrl,
    vippsCheckExistsUrl,
    getPinForTrustedClientUrl

} from '../config/url';
import { CSRFtoken } from '../config/config';

export default {
    userExist(username) {
        const params = { username, CSRFtoken };
        return axios
            .post(userExistUrl, params)
            .then(
                response => response.data === true || response.data === 'true'
            )
            .catch(() => false);
    },

    getPin(phoneNo) {
        const params = { phoneNo, CSRFtoken };
        return axios
            .get(getPinUrl, { params })
            .then(
                response =>
                    response.data.pin_sent === true ||
                    response.data.pin_sent === 'true'
            );
    },

    lookUp(phoneNo) {
        const params = { phoneNo, CSRFtoken };
        return axios
            .post(opplysningenLookupUrl, params)
            .then(response => {
                //const result = response.data.Results && Array.isArray(response.data.Results) && response.data.Results[0];
                const result = response.data;
                //const address = result.Addresses.find(address => address.AddressType === 0);
                if (result) {
                    const address = result.StreetAddress;
                    let middleName = '';

                    if (
                        Object.prototype.hasOwnProperty.call(result, 'Middlename') &&
                        result.Middlename !== undefined &&
                        result.Middlename.length > 0
                    ) {
                        middleName = ' ' + result.Middlename;
                    }
                    if (address) {
                        const concatenatedHouseNumber = address.HouseNumber.concat(
                            address.HouseLetter || ''
                        );
                        const concatenatedStreet = (address.StreetName || '')
                            .concat(' ')
                            .concat(concatenatedHouseNumber);
                        return {
                            firstName: result.Firstname + middleName,
                            lastName: result.Lastname || result.Companyname,
                            streetAddress: concatenatedStreet,
                            zipcode: address.PostalCode || '',
                            city: address.PostalArea || ''
                        };
                    }
                }
                return {
                    firstName: '',
                    lastName: '',
                    streetAddress: '',
                    zipcode: '',
                    city: ''
                };
            })
            .catch(function() {
                return {
                    firstName: '',
                    lastName: '',
                    streetAddress: '',
                    zipcode: '',
                    city: ''
                };
            });
    },

    userHasPasswordLogin(username) {
        const params = { username, CSRFtoken };
        return axios
            .post(passwordLoginUrl, params)
            .then(response => response.data)
            .catch(() => false);
    },
    
    userHasVippsLogin(username) {
        const params = { username, CSRFtoken };
        return axios
            .post(vippsCheckExistsUrl, params)
            .then(response => response.data)
            .catch(() => false);
    },

    getPinForTrustedClient(phoneNo, clientId, CSRFtoken) {
        const params = { phoneNo, CSRFtoken, clientId };
        return axios
            .get(getPinForTrustedClientUrl, { params })
            .then(
                response =>
                    response.data.pin_sent === true ||
                    response.data.pin_sent === 'true'
            );
    },
};
